var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('paginate',{attrs:{"click-handler":_vm.onChangePage,"page-count":_vm.pages,"prev-text":_vm.$t('prev'),"next-text":_vm.$t('next'),"container-class":'pagination',"page-class":'page-item',"page-link-class":'page-link',"next-class":'page-item',"next-link-class":'page-link',"prev-class":'page-item',"prev-link-class":'page-link'}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04c3f972","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DxPaginate.vue
// module id = null
// module chunks = 